/**
 * Branch context — Saheeh is single-tenant (one branch per deployment).
 * Stub kept so SushiKi-ported pages compile without changes.
 */

export const DEFAULT_BRANCH_ID = 'saheeh';

export function currentBranchId(): string {
  return DEFAULT_BRANCH_ID;
}

export function refreshBranchFromStoredUser(): string {
  return DEFAULT_BRANCH_ID;
}

export function setCurrentBranchId(_id: string): void {
  // no-op: single tenant
}

/** No categories are hidden by default. */
export function getHiddenCategories(): string[] {
  return [];
}
